export const bottomAppBarHeight = 56;
export const pageHeaderHeight = 49;